/*
创建者 魏强(2018.1.24)
限时特价 列表
*/
<template>
	 <ul class="clearfix">
        <li v-for="(item,index) in list " 
            v-if="index<6"
            :key="item.goods_id">
            <router-link :to="{path:'/goods',query:{goods_id:item.goods_id}}" target="_blank"> 
                <div class="image">
                    <img :src="item.thumbnail" class="image"> 
                </div>
                <div class="title" :title="item.NAME">{{item.NAME}}</div>
                <div class="price">
                    <span class="symbol">&yen;</span>{{item.price}}&nbsp;<span class="jsNum">&yen;{{item.mktprice}}</span>
                </div>
                <div class="store">库存：{{item.store}}件</div>
                <div class="button">抢购</div>
            </router-link>
        </li>
    </ul>
</template>
<script>
export default{
    props:["list"],
	data(){
		return {}
	}
}
</script>



// WEBPACK FOOTER //
// list.vue?2e3193c4